import { render, staticRenderFns } from "./TimeStyleEditor.vue?vue&type=template&id=4e4c2e56&"
import script from "./TimeStyleEditor.vue?vue&type=script&lang=ts&"
export * from "./TimeStyleEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports